import { FC } from 'react'
import cn from 'classnames'

import styles from './ActionButton.module.scss'

interface ActionButtonProps {
  id?: string
  type?: 'button' | 'submit' | 'reset'
  isDisabled?: boolean
  onClick: () => void
  className?: string
}

const ActionButton: FC<ActionButtonProps> = ({
  /* @ts-ignore TODO: remove ignore TS validation */
  children,
  id,
  isDisabled = false,
  type = 'button',
  onClick,
  className,
}) => {
  const testId = id ? `action-button-${id}` : 'action-button'

  const handleClick = () => {
    if (!isDisabled) {
      onClick()
    }
  }

  return (
    <button
      data-test-id={testId}
      type={type}
      className={cn(styles.button, isDisabled && styles.disabled, className)}
      onClick={handleClick}
    >
      {children}
    </button>
  )
}

export default ActionButton
